import React, { Component } from "react";
import '../styles/header.css';

import logoOne from './../imgs/brella.svg';
import logoTwo from './../imgs/hopin.svg';
import logoThree from './../imgs/grip.svg';
import logoFour from './../imgs/glisser.svg';
import logoFive from './../imgs/swapcard.svg';
import logoSix from './../imgs/hubilo.svg';
// import logoSeven from './../imgs/PA_Logo.svg';
// import logoEight from './../imgs/Thinkbox_Logo.svg';
// import logoNine from './../imgs/Uber_Logo.svg';
// import logoTen from './../imgs/PaddyPower_Logo.svg';
import cardLogo from './../imgs/logo.png';
import Slider from "react-slick";

export default class Header extends Component {
	render() {
		const settings = {
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplay: true,
			infinite: true,
			autoplaySpeed: 2000,
			arrows: false,
			responsive: [
				{
				breakpoint: 500,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,

					}
				},
				{
				breakpoint: 750,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,

					}
				},
				{
				breakpoint: 1350,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1,
					}
				},
			]
		  };
		return (

			<div>
				<link rel="stylesheet" type="text/css" charSet="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
				<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
				{/* <Navbar className="headerNav">
					<Navbar.Collapse className="justify-content-end">
					</Navbar.Collapse>
				</Navbar> */}
				<div className="card-person center">
					<a className="card-person__text" href="https://www.londonfilmed.com">Back to londonfilmed.com</a>
					<img className="card-person__one" src={cardLogo} />
				</div>
				<div className="header-logo">
					<Slider {...settings}>
						<div className="logo">
							<img className="" src={logoOne} alt="" width="200px" />
						</div>
						<div className="logo">
							<img className="" src={logoTwo} alt="" width="200px" />
						</div>
						<div className="logo">
							<img className="" src={logoThree} alt="" width="200px" />
						</div>
						{/*<div className="logo">*/}
						{/*	<img className="" src={logoFour} alt="" width="200px" />*/}
						{/*</div>*/}
						<div className="logo">
							<img className="" src={logoFive} alt="" width="200px" />
						</div>
						<div className="logo">
							<img className="" src={logoSix} alt="" width="200px" />
						</div>
					</Slider>
				</div>
			</div>
		)
	}
}
